<div *ngIf="flag == 'th'" >
<my-date-picker-th name="mydate" [options]="myDatePickerOption" [selDate]="selDate"
    placeholder="{{defaultPlaceholder}}" (dateChanged)="onDateChanged($event)"></my-date-picker-th>
</div>

<div *ngIf="flag == 'en'">
<my-date-picker name="mydateEN" [options]="myDatePickerOptions" [selDate]="selDate" placeholder="{{defaultPlaceholder}}"
    (dateChanged)="onDateChanged($event)"></my-date-picker>
</div>